/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-01-17 15:03:45
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { ButtonGroup, Button } from '@shopify/polaris';
import { EditMajor, DeleteMajor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { CirclePlusMinor } from '@shopify/polaris-icons';

type ComposedProps = WithI18nProps;
type State = {
  availableItems: number
};

const LIMIT_AVAILABLE_ITEMS = 30;

class TableRow extends Component<ComposedProps, State> {
  state = {
    availableItems: LIMIT_AVAILABLE_ITEMS
  };

  render() {
    const { item, index } = this.props;
    return (
      <>
        <tr className="Polaris-DataTable__TableRow" key={`sort-${index}`}>
          {/* Key */}
          <td className="Polaris-DataTable__Cell">{this.renderSortingOption(item.sortId)}</td>
          {/* Apply for */}
          <td className="Polaris-DataTable__Cell">
            {this.renderSortingCollections(item.collectionIds)}
          </td>

          {/* Actions */}
          <td className="Polaris-DataTable__Cell Polaris-DataTable__Cell-Action">
            {this.renderAction(index)}
          </td>
        </tr>
      </>
    );
  }

  // Render sorting value for per option
  renderSortingOption = (sortId: string) => {
    const { optionSorts } = this.props;
    const sortOption = _.find(optionSorts, item => item.value === sortId, {});
    return !_.isEmpty(sortOption) ? sortOption.label : '';
  };

  // Render sorting value for per option
  renderSortingCollections = (collections: Object) => {
    const { i18n, disabled } = this.props;
    const { availableItems } = this.state;
    const numberDisplay = collections.length > availableItems ? availableItems : collections.length;

    return (
      <div className="collections">
        {(function (rows, i, len) {
          while (i < len) {
            const item = collections[i];
            rows.push(
              <span className="Polaris-Tag BC-Custom__Tag" key={i}>
                <span className="Polaris-Tag__TagText">{item.label}</span>
              </span>
            );
            i++;
          }
          return rows;
        })([], 0, numberDisplay)}
        {numberDisplay < collections.length && (
          <span className="BC-Custom__ButtonMore">
            <Button plain onClick={this.handleViewMore} icon={CirclePlusMinor} disabled={disabled}>
              {i18n.translate('AdminHTML.Common.Action.more')}
            </Button>
          </span>
        )}
      </div>
    );
  };

  // Action view more
  handleViewMore = () => {
    this.setState(({ availableItems }) => ({
      availableItems: availableItems + LIMIT_AVAILABLE_ITEMS
    }));
  };

  // Render action button for per option
  renderAction = (id: number) => {
    const { handleActiveModalEdit, updateSelected, handleActiveOptionModalRemove, disabled } =
      this.props;
    return (
      <ButtonGroup segmented>
        <Button
          size="slim"
          icon={EditMajor}
          onClick={() => {
            handleActiveModalEdit(id);
          }}
          disabled={disabled}
        />
        <Button
          size="slim"
          icon={DeleteMajor}
          onClick={() => {
            updateSelected(id);
            handleActiveOptionModalRemove();
          }}
          disabled={disabled}
        />
      </ButtonGroup>
    );
  };
}

export default withI18n()(TableRow);
